import React from 'react';
import classnames from 'classnames'
import { Translate } from 'react-localize-redux';
import { withLocalize } from 'react-localize-redux';
import ResponsiveTable from '../../layoutItems/responsiveTable';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class CeeDetailConfirm extends React.Component {
    state = { yesClicked: false }
    render() {
        return (
            <React.Fragment>
                <span className="underlined-title-wrapper" style={{ marginTop: this.props.popup ? "0.5em" : "0" }}>
                    <h5 className="underlined-title" style={{ fontWeight: '600' }}>
                        {this.props.data.massRequest ?
                            <Translate id={this.props.data.option} data={{ count: this.props.data.count }} /> :
                            <Translate id="Search.Cee.Modal.Subheader" />
                        }
                    </h5>
                </span>
                {!this.props.data.massRequest &&
                    <ResponsiveTable style={{ marginTop: "2em" }}>
                        <table className="table table-report-section-2 w-100">
                            <tbody>
                                <tr className="colorize">
                                    <td className="bold" style={{ width: "25em" }}>
                                        <Translate id="Search.Cee.Cause.FileNo" />:
                                    </td>
                                    <td style={{ fontWeight: "600" }}>
                                        {this.props.data.exNumber}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </ResponsiveTable>}
                <div className="aml-warning-info">
                    <div>
                        <Translate id="Search.Cee.ConfirmQuestion" />
                        <sup>{this.props.data.country}</sup>?
                    </div>
                    <div>
                        <Translate id="Search.Cee.Modal.Credit" data={{ count: this.props.data.count }} />
                    </div>
                </div>
                <div className="modal-inner-buttons">
                    <button type='button' onClick={() => this.props.no()} className={classnames('bb-button is-primary gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })}>
                        <Translate id='Common.No.Upper' />
                    </button>
                    <button type='button' onClick={() => {
                        if (this.state.yesClicked)
                            return false;
                        else {
                            this.setState({ yesClicked: true });
                            this.props.yes();
                        }
                    }} className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}>
                        {this.state.yesClicked ? <FontAwesomeIcon icon='cog' spin={true} /> : < Translate id='Common.Yes.Upper' />}
                    </button>
                </div>
            </React.Fragment>
        )
    }
}

export default withLocalize(CeeDetailConfirm);